(() => {
  const body = document.body;
  const stack = document.querySelector('.xe-header-stack');
  const trigger = document.querySelector('.xe-search-trigger');
  const panel = document.querySelector('.xe-search-panel');
  if (!stack) return;

  const updateHeader = () => {
    const scrolled = window.scrollY > 48;
    body.classList.toggle('xe-scrolled', scrolled);
    if (panel) panel.style.setProperty('--xe-panel-top', `${stack.getBoundingClientRect().bottom}px`);
  };
  let scheduled = false;
  window.addEventListener('scroll', () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { updateHeader(); scheduled = false; });
  }, { passive: true });
  window.addEventListener('resize', updateHeader, { passive: true });
  updateHeader();

  if (trigger && panel) {
    const close = () => {
      body.classList.remove('xe-search-open');
      trigger.setAttribute('aria-expanded', 'false');
    };
    trigger.addEventListener('click', () => {
      const open = !body.classList.contains('xe-search-open');
      body.classList.toggle('xe-search-open', open);
      trigger.setAttribute('aria-expanded', String(open));
      document.querySelectorAll('.xe-main-menu details[open]').forEach(menu => menu.open = false);
      updateHeader();
      if (open) requestAnimationFrame(() => panel.querySelector('input[type="search"]')?.focus());
    });
    panel.querySelector('.xe-search-close')?.addEventListener('click', close);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') close();
    });
    document.addEventListener('click', event => {
      if (body.classList.contains('xe-search-open') && !panel.contains(event.target) && !trigger.contains(event.target)) close();
    });
  }

  document.querySelectorAll('.xe-main-menu .qa-menu-more details').forEach(menu => {
    document.addEventListener('click', event => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') menu.open = false;
    });
  });

  // Shopify's Predictive Search API returns 417 for this store's zh-TW buyer locale.
  // Reuse the storefront's regular product search as a small, same-origin fallback.
  if (document.documentElement.lang.toLowerCase().startsWith('zh')) {
    document.querySelectorAll('.xe-live-results').forEach(host => {
      const scope = host.closest('.xe-search-panel, #search-form-mobile');
      const input = scope?.querySelector('input[type="search"]');
      if (!scope || !input) return;
      let timer;
      let requestId = 0;
      const clear = () => {
        host.hidden = true;
        host.replaceChildren();
        scope.classList.remove('xe-has-results');
      };
      input.addEventListener('input', () => {
        clearTimeout(timer);
        const query = input.value.trim();
        const currentId = ++requestId;
        if (query.length < 2) { clear(); return; }
        timer = setTimeout(async () => {
          const searchUrl = `${host.dataset.searchUrl}?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=last`;
          try {
            const response = await fetch(searchUrl, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Search unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            if (currentId !== requestId) return;
            const cards = [...doc.querySelectorAll('.productListing.productGrid > .product')].slice(0, 4);
            const heading = document.createElement('p');
            heading.className = 'xe-live-results__heading';
            heading.textContent = cards.length ? '相關商品' : '沒有找到符合的商品';
            host.replaceChildren(heading);
            cards.forEach(card => {
              const original = card.querySelector('a.card-title[href^="/products/"]');
              if (!original) return;
              const item = document.createElement('a');
              item.className = 'xe-live-results__item';
              item.href = original.getAttribute('href');
              const title = document.createElement('span');
              title.textContent = original.textContent.trim();
              item.append(title);
              const priceText = card.querySelector('.card-price .price-item--sale, .card-price .price__regular .price-item--regular')?.textContent.trim();
              if (priceText) {
                const price = document.createElement('small');
                price.textContent = priceText;
                item.append(price);
              }
              host.append(item);
            });
            const all = document.createElement('a');
            all.className = 'xe-live-results__all';
            all.href = searchUrl;
            all.textContent = '查看完整搜尋結果 →';
            host.append(all);
            host.hidden = false;
            scope.classList.add('xe-has-results');
          } catch (_) {
            if (currentId === requestId) clear();
          }
        }, 280);
      });
    });
  }
})();
